import { AfterViewInit, Directive, HostListener, inject } from '@angular/core';
import { Select } from 'primeng/select';

@Directive({
  selector: '[appAdjustDropdownHeight]',
  standalone: true,
})
export class AdjustDropdownHeightDirective implements AfterViewInit {
  private readonly dropdown = inject(Select, { optional: true })!;

  constructor() {
    const dropdown = this.dropdown;

    if (!dropdown) {
      throw new Error('appAdjustDropdownHeight must be used on a p-dropdown component.');
    }
  }

  ngAfterViewInit() {
    this.adjustHeight();
  }

  @HostListener('onFilter')
  adjustHeight() {
    setTimeout(() => {
      if (!this.dropdown.overlayViewChild?.el) return;
      const list = this.dropdown?.scroller?.elementViewChild?.nativeElement;
      if (list) {
        const itemCount = this.dropdown.visibleOptions().length;

        const determineListHeight = (itemCount: number) => {
          if (itemCount > 0 && itemCount < 5) {
            return `${itemCount * 36}px`;
          } else if (itemCount == 0) {
            return '36px';
          } else {
            return '200px';
          }
        };

        list.style.height = determineListHeight(itemCount); // Adjust height dynamically
      }
    });
  }
}
